import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const JobUrl = `${Base_Url}/Job`;

export const GetJobList = async (params) => {
  const res = await postApiWithAuthorization(`${JobUrl}/GetJobList`, params);
  return res;
};

export const GetJobReportList = async (params) => {
  const res = await postApiWithAuthorization(`${JobUrl}/GetJobReportList`, params);
  return res;
};


export const GetClientPredefinedJobList = async (params) => {
  const res = await postApiWithAuthorization(
    `${JobUrl}/GetClientPredefinedJobList`,
    params
  );
  return res;
};

export const AddUpdateJob = async (params) => {
  const res = await postApiWithAuthorization(`${JobUrl}/AddUpdateJob`, params);
  return res;
};

export const GetJobModel = async (KeyID) => {

  const res = await getApiWithAuthorization(
    `${JobUrl}/GetJobModel?JobKeyID=${KeyID}`
  );
  return res;
};

export const GetJobInformationModel = async (ModuleName, KeyID, UserKeyID) => {
  const res = await getApiWithAuthorization(
    `${JobUrl}/GetJobInformationModel?ModuleName=${ModuleName}&JobKeyID=${KeyID}&UserKeyID=${UserKeyID}`
  );
  return res;
};
export const GetClientPredefinedJobModel = async (KeyID, UserKeyID) => {
  const res = await getApiWithAuthorization(
    `${JobUrl}/GetClientPredefinedJobModel?PredefinedJobKeyID=${KeyID}&UserKeyID=${UserKeyID}`
  );
  return res;
};
export const GetJobTimelineList = async (KeyID, UserKeyID) => {
  const res = await getApiWithAuthorization(
    `${JobUrl}/GetJobTimelineList?&JobKeyID=${KeyID}&UserKeyID=${UserKeyID}`
  );
  return res;
};

export const GetJobLookupList = async (UserKeyID, clientProjectID) => {
  let url = `${JobUrl}/GetJobLookupList?UserKeyID=${UserKeyID}`;

  // Append clientProjectID only if not null
  if (clientProjectID !== null) {
    url += `&clientProjectID=${clientProjectID}`;
  }

  const res = await getApiWithAuthorization(url);
  return res;
};

export const UpdateJobStatus = async (id) => {
  const res = await getApiWithAuthorization(
    `${JobUrl}/ChangeJobStatus?JobKeyID=${id}`,
  );

  return res;
};



export const GetJobCategoryLookupList = async () => {
  const res = await getApiWithAuthorization(`${Base_Url}/JobCategory/GetJobCategoryLookupList`);
  return res;
};

// UpdateJobStatus
export const UpdateStatusJob = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/Job/ChangeJobStatusWithRemark`,
    params
  );


  return res;
};


export const GetJobStatusLookupList = async () => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/Job/GetJobStatusLookupList`
  );
  return res;
};

export const getJobDetails = async (JobKeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/Job/GetJobDetails?JobKeyID=${JobKeyID}`
  );
  return res;
}